import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { ApolloProvider } from '@apollo/client';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';

import { track } from 'src/utils';
import { GROWTHBOOK_API_HOST, GROWTHBOOK_API_KEY } from './config';
import Routes from 'src/routes';
import client from 'src/service/apollo-service';
import './lib/i18n';
import { updateLocale } from './helpers/locale';
import { FEATURE_FLAGS } from './constants';

updateLocale();

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const gb = new GrowthBook({
  apiHost: GROWTHBOOK_API_HOST,
  clientKey: GROWTHBOOK_API_KEY,
  trackingCallback: (experiment, result) => {
    if (result.featureId === FEATURE_FLAGS.SUBSCRIPTION_UPGRADE_AB_TEST_KEY) {
      track('Experiment Viewed', {
        experimentId: experiment.key,
        variantId: result.key
      });
    }
  }
});

const theme = createTheme({
  typography: {
    fontFamily: ['Lato', 'sans-serif'].join(',')
  }
});

const App = () => {

  useEffect(() => {
    gb.loadFeatures();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider
            dense
            maxSnack={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <ApolloProvider client={client}>
              <Router history={history}>
                <GrowthBookProvider growthbook={gb}>
                  <Routes />
                </GrowthBookProvider>
              </Router>
            </ApolloProvider>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
